import { render } from "./market-switcher-trigger.vue?vue&type=template&id=954ac25a"
import script from "./market-switcher-trigger.vue?vue&type=script&lang=js"
export * from "./market-switcher-trigger.vue?vue&type=script&lang=js"

import "./market-switcher-trigger.vue?vue&type=style&index=0&id=954ac25a&lang=scss"

import exportComponent from "/Users/andrewamistad/Sites/lyle-and-scott/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__